<template>
  <section>
    <list :type="5"></list>
  </section>
</template>

<script>
import list from '../policy/list'
export default {
  name: 'paid',
  components:{
    list
  },
}
</script>

<style scoped>

</style>
